import { useQuery } from "@tanstack/react-query";
import { doorbellChimeApi } from "@/lib/api/doorbell-chime";

export const DOORBELL_CHIME_KEY = ["doorbell-chime"] as const;

/** The company's chime sirens — company admins only (the endpoint answers 403 to members, so nobody else asks). */
export function useDoorbellChime(enabled = true) {
  return useQuery({
    queryKey: DOORBELL_CHIME_KEY,
    queryFn: () => doorbellChimeApi.list().then((r) => r.data),
    enabled,
    retry: false,
    staleTime: 30_000,
  });
}
